import { Action, combineReducers } from "@reduxjs/toolkit";

import {
	autodetectPhone,
	autodetectPhoneAction,
	StateAutodetectPhones,
} from "./AutodetectPhone";
import {
	counterparty,
	counterpartyAction,
	StateCounterparty,
} from "./Counterparties";
import { agents, agentsAction, StateAgents } from "./Agents";
import { clients, clientsAction, StateClients } from "./Clients";

export type State = {
	autodetectPhone: StateAutodetectPhones;
	counterparty: StateCounterparty;
	agents: StateAgents;
	clients: StateClients;
};

export type Actions = {
	autodetectPhone: typeof autodetectPhoneAction;
	counterparty: typeof counterpartyAction;
	agents: typeof agentsAction;
	clients: typeof clientsAction;
};

export const customersReducer = combineReducers<State, Action<Actions>>({
	autodetectPhone,
	counterparty,
	agents,
	clients,
});

export const customersAction: Actions = {
	autodetectPhone: autodetectPhoneAction,
	counterparty: counterpartyAction,
	agents: agentsAction,
	clients: clientsAction,
};

export default customersReducer;
